import { CircularProgress, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import ModalNew from "../Modals/ModalNew";
import { ButtonStyledNew, CollabText, CollabTitle } from "../Typography/NewTypography";

const ModalStyled = styled(ModalNew)({
  "& .wrapper": {
    width: "520px",
    maxWidth: "calc(100vw - 48px)",
  },
});

const BodyStyled = styled("div")({
  padding: "0.5rem 1.5rem 0",
  "& .afm-check-loading": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
    textAlign: "center",
  },
  "& .afm-check-info": {
    alignSelf: "stretch",
    textAlign: "left",
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    gap: "0.5rem 1.5rem",
    padding: "0.75rem 1rem",
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    backgroundColor: "#fff",
  },
  "& .afm-check-label": {
    color: "#757575",
  },
  "& .afm-check-detail": {
    whiteSpace: "pre-line",
  },
  "& .afm-check-actions": {
    display: "flex",
    justifyContent: "flex-end",
    gap: "0.5rem",
    marginTop: "1.5rem",
  },
});

const AfmCheckDialog = ({ afmCheck }) => {
  const { t } = useTranslation();
  const {
    isChecking,
    checkedPerson,
    isNoticeOpen,
    errorType,
    detail,
    confirm,
    cancel,
  } = afmCheck;
  const isTimeout = errorType === "Timeout";

  return (
    <ModalStyled
      isOpen={isChecking || isNoticeOpen}
      onClose={cancel}
      modalTitle={
        <CollabTitle>
          {errorType
            ? t(`AfmCheck.${errorType}Title`)
            : isNoticeOpen
              ? t("AfmCheck.Title")
              : t("AfmCheck.CheckingTitle")}
        </CollabTitle>
      }
    >
      <BodyStyled>
        {isNoticeOpen ? (
          <>
            <CollabText component="div" className="afm-check-detail">
              {errorType ? t(`AfmCheck.${errorType}`) : detail}
            </CollabText>
            <div className="afm-check-actions">
              <ButtonStyledNew variant="danger" onClick={cancel}>
                {isTimeout ? t("AfmCheck.Close") : t("Global.Cancel")}
              </ButtonStyledNew>
              {!isTimeout && (
                <ButtonStyledNew variant="filled" onClick={confirm}>
                  {t("AfmCheck.Continue")}
                </ButtonStyledNew>
              )}
            </div>
          </>
        ) : (
          <div className="afm-check-loading">
            <div className="afm-check-info">
              {checkedPerson?.name && (
                <>
                  <CollabText component="div" className="afm-check-label">
                    {t("AfmCheck.Name")}
                  </CollabText>
                  <CollabText component="div">{checkedPerson.name}</CollabText>
                </>
              )}
              <CollabText component="div" className="afm-check-label">
                {t("AfmCheck.TaxNumber")}
              </CollabText>
              <CollabText component="div">{checkedPerson?.taxNumber}</CollabText>
            </div>
            <CollabText component="div">{t("AfmCheck.CheckingDescription")}</CollabText>
            <CircularProgress size={28} />
          </div>
        )}
      </BodyStyled>
    </ModalStyled>
  );
};

export default AfmCheckDialog;
